<!-- 
  팝업 사이즈 
  클래스 small = 400px
  클래스 medium = 560px *디폴트
  클래스 large = 1000px
-->
<template>
  <div v-if="model" class="overlay_popup" ref="popupModel">
    <div class="bg_overlay"></div>
    <div class="popup_container">
      <div class="popup_title">
        <button type="button" class="popup_close" @click="onClickClose()">닫기</button>
        <h3 v-if="$slots.title">
          <!-- template v-slot:title (Start) -->
          <slot name="title"></slot>
          <!-- template v-slot:title (End) -->
        </h3>
      </div>
      <div class="popup_content" :class="[loading ? 'loading_md' : '', contentClass]">
        <slot></slot>
      </div>
      <div class="popup_footer">
        <slot name="footer" :close="onClickClose"></slot>
        <!-- template v-slot:content -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { watch, onMounted, onUnmounted } from "vue";
import { popupHeight } from "@/common/js/popup";
import { accordion } from "@/common/js/common";

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel();

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
defineProps({
  loading: { type: Boolean, default: false },
  contentClass: { type: String, default: "" },
});

/* ------------------------------------------------------------
                          Methods
   ------------------------------------------------------------ */
/** 닫기 버튼 클릭 시 */
const onClickClose = () => {
  model.value = false;
};

/* ------------------------------------------------------------
                          watch
   ------------------------------------------------------------ */
/** 모델 변경 시 팝업 상태 관리 */
watch(model, (newVal) => {
  if (newVal) {
    setTimeout(() => {
      popupHeight();
      // letterCount();
      accordion();
      document.body.classList.add("on");
    }, 200);
  } else {
    document.body.classList.remove("on");
  }
});

/* ------------------------------------------------------------
                          Lifecycle
   ------------------------------------------------------------ */
onMounted(() => {
  if (model.value) {
    setTimeout(() => {
      document.body.classList.add("on");
    }, 200);
  }
  popupHeight();
  // letterCount();
  accordion();
});

onUnmounted(() => {
  const overlays = document.querySelectorAll(".overlay_popup");
  if (overlays.length === 0) {
    document.body.classList.remove("on");
  }
});
</script>
